// extracted by mini-css-extract-plugin
export var button = "order-result-module--button--9rwAH";
export var container = "order-result-module--container--+oEG4";
export var contentBox = "order-result-module--content-box--VNhY3";
export var disclaimer = "order-result-module--disclaimer--MMOdh";
export var emotics = "order-result-module--emotics--BhIaH";
export var infoIcon = "order-result-module--info-icon--LF0iC";
export var text = "order-result-module--text--RUPce";
export var titleText = "order-result-module--title-text--63wXK";